import firedux from '../firedux'
import {dispatch} from '../store'

import {
  GROUP_CHAT_SUBSCRIPTION_TYPES,
  GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT
} from '../../config/constants'

const {INSTANT, DAILY, WEEKLY} = GROUP_CHAT_SUBSCRIPTION_TYPES

import setSubscribedGroups from '../actions/set_subscribed_groups'
import removeSubscribedGroup from '../actions/remove_subscribed_group'

const onSubscribedGroups = (uid, snapshot, scope) => {
  const groups = snapshot.val()

  return dispatch(setSubscribedGroups(uid, groups, scope))
}

const onSubscribedGroupsInstant = (uid, snapshot) => onSubscribedGroups(uid, snapshot, INSTANT)
const onSubscribedGroupsDaily = (uid, snapshot) => onSubscribedGroups(uid, snapshot, DAILY)
const onSubscribedGroupsWeekly = (uid, snapshot) => onSubscribedGroups(uid, snapshot, WEEKLY)

const onSubscribedGroupRemoved = (uid, snapshot, scope) => {
  const key = snapshot.key()

  dispatch(removeSubscribedGroup(uid, key, scope))
}

const onSubscribedGroupInstantRemoved = (uid, snapshot) => onSubscribedGroupRemoved(uid, snapshot, INSTANT)
const onSubscribedGroupDailyRemoved = (uid, snapshot) => onSubscribedGroupRemoved(uid, snapshot, DAILY)
const onSubscribedGroupWeeklyRemoved = (uid, snapshot) => onSubscribedGroupRemoved(uid, snapshot, WEEKLY)

export const watchUserGroupChatInstantSubscriptions = (uid) => {
  if (!uid) return

  const ref = firedux.ref.child(GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT).child(INSTANT).child(uid)

  ref.on('value', onSubscribedGroupsInstant.bind(null, uid))
  ref.on('child_removed', onSubscribedGroupInstantRemoved.bind(null, uid))
}

export const unwatchUserGroupChatInstantSubscriptions = (uid) => {
  if (!uid) return

  const ref = firedux.ref.child(GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT).child(INSTANT).child(uid)

  ref.off('value')
  ref.off('child_removed')
}

export const watchUserGroupChatDailySubscriptions = (uid) => {
  if (!uid) return

  const ref = firedux.ref.child(GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT).child(DAILY).child(uid)

  ref.on('value', onSubscribedGroupsDaily.bind(null, uid))
  ref.on('child_removed', onSubscribedGroupDailyRemoved.bind(null, uid))
}

export const unwatchUserGroupChatDailySubscriptions = (uid) => {
  if (!uid) return

  const ref = firedux.ref.child(GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT).child(DAILY).child(uid)

  ref.off('value')
  ref.off('child_removed')
}

export const watchUserGroupChatWeeklySubscriptions = (uid) => {
  if (!uid) return

  const ref = firedux.ref.child(GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT).child(WEEKLY).child(uid)

  ref.on('value', onSubscribedGroupsWeekly.bind(null, uid))
  ref.on('child_removed', onSubscribedGroupWeeklyRemoved.bind(null, uid))
}

export const unwatchUserGroupChatWeeklySubscriptions = (uid) => {
  if (!uid) return

  const ref = firedux.ref.child(GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT).child(WEEKLY).child(uid)

  ref.off('value')
  ref.off('child_removed')
}

export const watchUserGroupChatSubscriptions = (uid) => {
  if (!uid) return

  watchUserGroupChatInstantSubscriptions(uid)
  watchUserGroupChatDailySubscriptions(uid)
  watchUserGroupChatWeeklySubscriptions(uid)
}

export const unwatchUserGroupChatSubscriptions = (uid) => {
  if (!uid) return

  unwatchUserGroupChatInstantSubscriptions(uid)
  unwatchUserGroupChatDailySubscriptions(uid)
  unwatchUserGroupChatWeeklySubscriptions(uid)
}




/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/subscribed_group_chats.js
 **/